module.exports = __webpack_public_path__ + "img/index-step.1d03a45f.png";